export const GET_GOOGLE_QR = "GET_GOOGLE_QR";
export const GET_GOOGLE_QR_SUCCESS = "GET_GOOGLE_QR_SUCCESS";
export const GET_GOOGLE_QR_FAIL = "GET_GOOGLE_QR_FAIL";

export const ADD_GOOGLE_QR_SUCCESS = "ADD_GOOGLE_QR_SUCCESS";
export const ADD_GOOGLE_QR_FAIL = "ADD_GOOGLE_QR_FAIL";
export const UPDATE_GOOGLE_QR_SUCCESS = "UPDATE_GOOGLE_QR_SUCCESS";
export const DELETE_GOOGLE_QR_SUCCESS = "DELETE_GOOGLE_QR_SUCCESS";
